import { SpriteSvgType } from '../../components/sprite-svg';
import {
  ServiceBusiness,
  ServiceSupportType,
  CommonStatusStep,
} from '../api-modules';

export enum SystemMenuId {
  Overview = 'overview',
  GameInfo = 'game_info',
  Matchmaking = 'matchmaking',
  Battle = 'battle',
  BuildGroup = 'build_group',
  BuildGadgets = 'build_gadgets',
  BuildMatchmaking = 'build_matchmaking',
  BuildBattle = 'build_battle',
  Player = 'build_player',
  Hosting = 'build_ds_hosting',
  BuildSocial = 'build_social',
  Account = 'account',
  CustomData = 'custom_data',
  Gadgets = 'gadgets',
  AutoTask = 'auto-task',
  LeaderBoards = 'leader_boards',
  Organization = 'organization',
  Message = 'message',
  Economy = 'economy',
  GameItems = 'game_items',
  Store = 'store',
  Engagement = 'engagement',
  Commands = 'commands',
  Mail = 'mail',
  ProjectSpace = 'project_space',
  SupportAccess = 'support_access',
  ProjectOrganization = 'project_organization',
  StudioManage = 'studio_manage',
  ServiceManage = 'service_manage',
  ServiceOnline = 'service_online',
  PriceManagement = 'price_management',
  PriceCalculator = 'price_calculator',
  CompanyAuth = 'company_auth',
  DownLoadManage = 'downLoad_manage',
  DownLoadRecord = 'downLoad_record',
  DownLoadNews = 'download_news',
  BusinessAccount = 'business_account',
  GauthFail = 'gauth-fail',
  CustomerService = 'customer_service',
  PlatformOperation = 'platform_operation',
  TitleManage = 'title_manage',
  ServiceApplication = 'service_application',
  MessagePush = 'message_push',
  BusinessNotice = 'business_notice',
  MailRecord = 'mail_record',
  UpgradeNotification = 'upgrade_notification',
  UserManage = 'user_manage',
  UserListManage = 'user_list_manage',
  AdminAccountManage = 'admin_account_manage',
  APPConfig = 'app_config',
  Migration = 'migration',

  GameMigration = 'game_migration',
  GameManage = 'game_manage',
  GameList = 'game_list',
  PermissionManage = 'permission_manage',
  PermissionList = 'permission_list',
  SupportPermissionList = 'support_permission_list',
  BillingManage = 'billing_manage',
  WithdrawalList = 'withdrawal_list',
}

export enum SystemMenuType {
  Group, // 分组菜单
  Menu, // 菜单节点
}
export interface ISystemMenuItem {
  readonly type: SystemMenuType;
  readonly id: string;
  readonly name: string;
  readonly url?: string;
  readonly subMenus?: ReadonlyArray<ISystemMenuItem>;
  readonly icon?: SpriteSvgType | string;
  readonly hidden?: boolean;
  readonly fixed?: boolean;
  readonly supportType?: ServiceSupportType;
  readonly servicePath?: string;
  readonly business?: ServiceBusiness;
  readonly status?: CommonStatusStep;
}

export interface ISystemMenuItemSub {
  readonly id: SystemMenuId;
  readonly name: string;
  readonly icon: SpriteSvgType;
  readonly gameid: string;
}
